export function listBalanceSmartPay(term) {
  const query = `{
  listAccountStatement(initialDate: ${term.initialDate.getTime()}, finalDate: ${term.finalDate.getTime()}) {
    valueInTransit
    listOfTransactions {
      id
      accountId
      recordType
      description
      value
      valueInformat
      dateInFormat
      invoiceId
      documentId
      integrationId
      contractNumber
      studentName
      withdrawId
      withdrawStatus
      responsibleName
      invoiceDueDateInFormat
    }
  }
}
`;
  return query;
}

export function accountValues() {
  const query = `{accountValues{
      balance
    }
}`;
  return query;
}
